export default __webpack_public_path__ + "static/media/outside.f915e406.jpg";